<form [formGroup]="form" class="form declarations">
<div class="preamble">Thank you for your notification.</div>
    
    <p>Your notification reference number is: <strong>{{acknowledgementNotificationData.notificationReferenceNumber}}</strong>.</p>
    <p>You will receive a confirmation of receipt of your notification via email.</p>
    <p>If you haven't received the confirmation of receipt within 24 hours, please contact us. Your options are:</p>
    <ul>
        <li>Phone: 135VEG (13 58 34)</li>
        <li>Email: vegetation&#64;nrmmrrd.qld.gov.au</li>
        <li>Submit an <a href="https://www.nrmmrrd.qld.gov.au/contact-us#vegetation-management">online enquiry</a></li>
    </ul>

    <p>Do you wish to notify for another clearing purpose?</p>
       
    <ul class="actions">
        <li>
            <em><input class="qg-btn btn-primary" type="submit" (click)="currentLot()" value="Yes - on this lot on plan" /></em>            
        </li>       
        <li>
            <em><input class="qg-btn btn-primary" type="submit" (click)="newLot()" value="Yes - Another lot" /></em>            
        </li>        
        <li>
            <input class="qg-btn btn-global-secondary" type="submit" (click)="finish()" value="No Finish" />            
        </li>
    </ul>
</form> 
